export const getPrefersReducedMotion = () => {
  const QUERY = '(prefers-reduced-motion: no-preference)';

  const mediaQueryList = window.matchMedia(QUERY);
  const prefersReducedMotion = !mediaQueryList.matches;

  return prefersReducedMotion;
};
